/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/prefer-default-export */
import React from 'react'

import clsx from 'clsx'

import s from './HowItWorks.module.css'
import { Step } from './components/Step'

const STEPS = [
  {
    video: '/assets/search.mp4',
    step: 'STEP 1',
    title: 'Search',
    desc: <>Browse hundreds of listings updated daily to find your next home.</>,
  },
  {
    video: '/assets/tour.mp4',
    step: 'STEP 2',
    title: 'Tour',
    desc: <>Reach out to our team and they can show you any property on the website.</>,
  },
  {
    video: '/assets/apply.mp4',
    step: 'STEP 3',
    title: 'Apply',
    desc: <>When you’ve found it - apply to secure your next apartment. </>,
  },
  {
    video: '/assets/lease.mp4',
    step: 'STEP 4',
    title: 'Lease',
    desc: <>Finalize the details, get the keys, and settle into your new space—welcome home!</>,
  },
]

export function HowItWorks() {
  return (
    <div className={s.root} id="how-it-works">
      <div className={s.title}>How Nooklyn Works</div>

      <div className={s.steps}>
        {STEPS.map((step) => (
          <Step key={step.step} {...step} />
        ))}

        <div className={s.stepDots}>
          <div className={clsx(s.stepDot, s.stepDotActive)} />
          <div className={s.stepDot} />
          <div className={s.stepDot} />
          <div className={s.stepDot} />
          <div className={s.stepDot} />
        </div>

        <svg
          className={s.line}
          xmlns="http://www.w3.org/2000/svg"
          width="2"
          height="1562"
          viewBox="0 0 2 1562"
          fill="none"
        >
          <path d="M1 0L1.00007 1562" stroke="url(#paint0_linear_1667_2818)" />
          <defs>
            <linearGradient
              id="paint0_linear_1667_2818"
              x1="1.50005"
              y1="1562"
              x2="1.49998"
              y2="-2.18552e-08"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#949494" stopOpacity="0" />
              <stop offset="0.125" stopColor="#949494" />
            </linearGradient>
          </defs>
        </svg>

        <svg
          className={s.lineMobile}
          xmlns="http://www.w3.org/2000/svg"
          width="2"
          height="2355"
          viewBox="0 0 2 2355"
          fill="none"
        >
          <path d="M1 0L1.0001 2355" stroke="url(#paint0_linear_1669_7002)" />
          <defs>
            <linearGradient
              id="paint0_linear_1669_7002"
              x1="1.50009"
              y1="2355"
              x2="1.49998"
              y2="-2.18547e-08"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#949494" stopOpacity="0" />
              <stop offset="0.125" stopColor="#949494" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  )
}
